import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {withRouter} from 'react-router';

import CollectionsMenuItem from './CollectionsMenuItem.js';

const CollectionsMenu = ({ clang, items }) => {
    return (
        <div className="collections__menu">
            <ul className="collections__menu-list">
                {items.map((item, index) =>
                    <CollectionsMenuItem key={index} {...item}/>)}
            </ul>
        </div>
    );
};

CollectionsMenu.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(CollectionsMenu));



// WEBPACK FOOTER //
// ./src/components/collections/CollectionsMenu.js